import { Component } from '@angular/core';

@Component({
  selector: 'description-icon',
  standalone: true,
  imports: [],
  templateUrl: './description.component.html',
  styleUrl: './description.component.scss'
})
export class DescriptionIcon {}